import {SafeUrl} from "@angular/platform-browser";

export class ImageModel {
  public altText?: string;
  public srcUrl?: SafeUrl;
  constructor(
    public type: string,
    public file: string
  ){}
}
